import { render, staticRenderFns } from "./SofortForm.vue?vue&type=template&id=3aea9669&"
import script from "./SofortForm.vue?vue&type=script&lang=js&"
export * from "./SofortForm.vue?vue&type=script&lang=js&"
import style0 from "./SofortForm.vue?vue&type=style&index=0&id=3aea9669&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports